<template>
    <modal-component 
        :title="$helpers.trans('auth.login')" 
        :open="open" 
        @close="$emit('update:open', false)">

        <form-component 
            name="Login" 
            action="/login" 
            :success-message="$helpers.trans('auth.loginSucceeded')"
            @success="loginComplete($event)"
            :spam-filter="false">
            <div class="form-group">
                <input id="login_email" type="email" required class="form-control" :class="{ 'used': user.email }" name="email" v-model="user.email">
                <label for="login_email" class="form-label">
                    <div class="form-label__content">{{ $helpers.trans('auth.email') }}</div>
                </label>
                <span class="bar"></span>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <input id="login_password" type="password" required class="form-control" :class="{ 'used': user.password }" name="password" v-model="user.password">
                <label for="login_password" class="form-label">
                    <div class="form-label__content">{{ $helpers.trans('auth.password') }}</div>
                </label>
                <span class="bar"></span>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <div class="col-md-6 col-md-offset-4">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" name="remember" class="form-check-input" v-model="user.remember"> {{ $helpers.trans('auth.rememberUser') }}
                            <div class="invalid-feedback"></div>
                        </label>
                    </div>
                </div>
            </div>

            <div slot="submit" slot-scope="slotProps" class="form-group">
                <button type="submit" class="btn btn-primary" @click.prevent="slotProps.submit()">
                    <i class="fal fa-btn fa-sign-in"></i> {{ $helpers.trans('auth.login') }}
                </button>

                <a class="btn btn-link" href="/password/reset">{{ $helpers.trans('auth.passwordReset') }}</a>
            </div>
        </form-component>
    </modal-component>
</template>
<script>
import ModalComponent from '#app#/components/common/Modal.vue'
import FormComponent from '#app#/components/common/Form.vue'

export default {
    components: {
        ModalComponent,
        FormComponent
    },
    props: ['open'],
    data() {
        return {
            user: {
                email: null,
                password: null,
                remember: false,
            },
        }
    },

    methods: {
        loginComplete(event) {
            window.location.reload();
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/package/RF/Member/modals/Login.vue